import { computed } from 'vue';
import { useStrapiUrl } from './useStrapiUrl.js';

export function useCommonStyles(props) {
  // Use centralized Strapi URL management
  const { getStrapiUrl } = useStrapiUrl();
  const backgroundImageStyle = computed(() => {
    if (props.page && props.page.heroImage) {
      return {
        backgroundImage: `url(${getStrapiUrl(props.page.heroImage.url)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
      };
    }
    return {};
  });

  const additionalContentBackgroundStyle = computed(() => {
    if (props.additionalContentWithMedia && 
        props.additionalContentWithMedia.length > 0 && 
        props.additionalContentWithMedia[0]?.backgroundImage) {
      return {
        backgroundImage: `url(${getStrapiUrl(props.additionalContentWithMedia[0].backgroundImage.url)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
      };
    }
    return {};
  });

  const getItemStyle = (item, index, fallbackColors = ['#7F73E6', '#4991FF', '#00B3E8']) => {
    if (item.featuredImage) {
      return {
        'background-image': `url(${getStrapiUrl(item.featuredImage.url)})`,
        'background-size': 'cover',
        'background-position': 'center',
      };
    } else {
      return {
        'background-color': fallbackColors[index % fallbackColors.length],
      };
    }
  };

  // getStrapiUrl is now provided by useStrapiUrl composable

  return {
    backgroundImageStyle,
    additionalContentBackgroundStyle,
    getItemStyle
  };
}
